/**
 * @generated SignedSource<<e35759c6624b756fc208bae1f1f38260>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type StickyHeader$data = {
  readonly repository: {
    readonly isWritable: boolean;
  };
  readonly state: IssueState;
  readonly stateReason: IssueStateReason | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"StickyHeaderChips" | "StickySubscribeButtonFragment" | "StickySubscribeButtonRefetchableFragment">;
  readonly " $fragmentType": "StickyHeader";
};
export type StickyHeader$key = {
  readonly " $data"?: StickyHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"StickyHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StickyHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWritable",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StickyHeaderChips"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StickySubscribeButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StickySubscribeButtonRefetchableFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "d54bf4501c75cabefa6406307be8a489";

export default node;
